<template>
    <div>
        <h3 class="h6 block-title border-bottom ps-0 mb-3">
            <i class="text-primary fa fa-fw fa-user text-muted me-1"></i>
            Commandes en cours
        </h3>
        <div class="mb-3 row" v-if="incompletedOrders.length > 0">
            <div class="col-6 col-md-4" v-for="order in incompletedOrders" :key="order.id">
                <div class="block shadow-sm" id="payment-attempt">
                    <div class="block-header bg-primary-lighter">
                        <h3 class="block-title">Commande n°{{ order.id }}</h3>
                    </div>
                    <!-- <span>{{this.order_incomplete[0].total_price}}</span> -->
                    <div class="block-content pb-3" >
                        <div class="bg-white p-2 rounded">
                            <span class="fw-bold"></span>
                            <div class="w-100 d-flex flex-column mt-2">
                                <ul v-for="item in order.items" :key="item.id">
                                    <li>{{ item.quantity }} x {{ item.itemable.name }}</li>
                                </ul>
                                <div class="mb-3" v-if="incompletedOrders.current_price != 0">
                                    <div v-for="invoice in order.invoices" :key="invoice.id">
                                        <span v-if="invoice.payment_method" class="badge bg-primary rounded-pill">{{ invoice.payment_method.name }}</span>
                                        <span v-else class="badge bg-primary rounded-pill">Prépaiement</span>
                                        <span>{{ invoice.amount }}€</span>
                                    </div>
                                </div>
                                <span
                                    ><b>Montant restant : </b>{{ parseFloat(order.total_price - order.current_price).toFixed(2) }}€</span
                                >
                            </div>
                            <div class="mt-3">
                                <a
                                    :href="'/back-office/add/order/basket/' + order.id"
                                    type="button"
                                    min="0"
                                    step="0.01"
                                    name="load_panel"
                                    id="1"
                                    placeholder="Prix"
                                    class="btn btn-primary text-white w-100"
                                >
                                    <span>Charger le panier</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="alert alert-warning" role="alert">
            <p class="mb-0">
              Pas de ventes en attente.
            </p>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'incompletedOrders'
    ],
    data: () => ({

    }),
    mounted() {
    },
}
</script>

<style></style>
